export default __webpack_public_path__ + "assets/images/decor.497f01.png";